const handleAccordionToggle = (el: Element | null): boolean => {
  const accordionWrapper = el?.closest('.accordion--item');

  if (accordionWrapper instanceof Element) {
    accordionWrapper?.classList.toggle('accordion--item--open');
    const accordionContent = accordionWrapper.querySelector(
      '.accordion--item--content'
    );

    if (accordionContent instanceof HTMLElement) {
      jQuery(accordionContent).slideToggle('slow', () => {
        const openPanel = el?.closest(
          '.scrolling-accordion .accordion .accordion--item--open'
        );
        openPanel?.scrollIntoView({ behavior: 'smooth' });
      });

      if (accordionContent.getAttribute('aria-hidden') === 'true') {
        accordionContent.setAttribute('aria-hidden', String(false));
      } else {
        accordionContent.setAttribute('aria-hidden', String(true));
      }
    }

    const accordionHeader = accordionWrapper.querySelector(
      '.accordion--item--header'
    );

    if (accordionHeader instanceof HTMLElement) {
      if (accordionHeader.getAttribute('aria-expanded') === 'true') {
        accordionHeader.setAttribute('aria-expanded', String(false));
      } else {
        accordionHeader.setAttribute('aria-expanded', String(true));
      }
    }
  }

  return false;
};

export const toggleAccessibility = (element: Element | null): void => {
  if (!element || !(element instanceof Element)) {
    return;
  }

  if (!element.hasAttribute('aria-expanded')) {
    element.setAttribute('aria-expanded', String(false));
    return;
  }

  if (element.getAttribute('aria-expanded') === 'true') {
    element.setAttribute('aria-expanded', String(false));
  } else {
    element.setAttribute('aria-expanded', String(true));
  }
};

const handleAccordionEvents = (event: Event | KeyboardEvent): void => {
  if (
    (event.type === 'click' ||
      (event instanceof KeyboardEvent &&
        (event.code === 'Enter' || event.code === 'Space'))) &&
    event.target instanceof Element
  ) {
    event.preventDefault();
    handleAccordionToggle(event.target);
    const accordionContent = document.getElementById(
      event.target.getAttribute('aria-controls') || ''
    );
    if (!(accordionContent instanceof HTMLElement)) {
      return;
    }
  }
};

const handleExpandCollapse = (event: Event | KeyboardEvent): void => {
  if (
    (event.type === 'click' ||
      (event instanceof KeyboardEvent &&
        (event.code === 'Enter' || event.code === 'Space'))) &&
    event.target instanceof Element
  ) {
    event.preventDefault();

    // Get the expand name
    const expandName = event.target.getAttribute('data-expand-collapse') ?? '';

    //Fid target elements
    const targetElements = document.querySelectorAll(
      `[data-expand-collapse-content="${expandName}"]`
    );

    //Toggle all open open
    targetElements.forEach((element) => {
      element.classList.remove('hide');
      element.classList.add('expanded');
    });

    const buttonsToRemove = document.querySelectorAll(
      `[data-expand-collapse="${expandName}"][data-expand-collapse-remove]`
    );

    //hide the button
    buttonsToRemove.forEach((element) => {
      element.classList.remove('show');
      element.classList.add('hide');
    });
  }
};

export const initAccordions = (): void => {
  const accordionItems = document.querySelectorAll(
    '.accordion .accordion--item .accordion--item--header'
  );

  accordionItems?.forEach((accordionItem) => {
    accordionItem.addEventListener('click', handleAccordionEvents);
    accordionItem.addEventListener('keydown', handleAccordionEvents);
  });

  const expandCollapse = document.querySelectorAll('[data-expand-collapse]');
  expandCollapse.forEach((trigger) => {
    trigger.addEventListener('click', handleExpandCollapse);
    trigger.addEventListener('keydown', handleExpandCollapse);
  });
};
